import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";

const salarySelector = (state: RootState) => state.salary;

const getSalaryDetailSelector = createSelector(
  salarySelector,
  (state) => state.getSalaryDetail
);

export const salaryDetailDataSelector = createSelector(
  getSalaryDetailSelector,
  (state) => state.data
);

export const salaryDetailStatusSelector = createSelector(
  getSalaryDetailSelector,
  (state) => state.status
);

const verifyIncomeOtpStateSelector = createSelector(
  salarySelector,
  (state) => state.verifyIncomeOtp
);

export const verifyIncomeOtpStatusSelector = createSelector(
  verifyIncomeOtpStateSelector,
  (state) => state.status
);

export const verifyIncomeOtpSectionSelector = createSelector(
  verifyIncomeOtpStateSelector,
  (state) => state.section
);

export const salaryDetailIsShowSelector = createSelector(
  getSalaryDetailSelector,
  (state) => state.isShow
);

export const listNotifyIncomeSelector = createSelector(
  salarySelector,
  (state) => state.getListNotifyIncome.data
);

export const filterSalaryNotifyIncomeSelector = createSelector(
  salarySelector,
  (state) => state.getListNotifyIncome.filter
);

export const currentMonthYearNotifyIncomeSelector = createSelector(
  salarySelector,
  (state) => state.getListNotifyIncome.otherData
);

export const listNotifyIncomeStatusSelector = createSelector(
  salarySelector,
  (state) => state.getListNotifyIncome.status
);

export const detailNotifyIncomeStatusSelector = createSelector(
  salarySelector,
  (state) => state.getDetailNotifyIncome.status
);

export const detailNotifyIncomeSelector = createSelector(
  salarySelector,
  (state) => state.getDetailNotifyIncome.data
);

export const selectedNotifyIncomeSelector = createSelector(
  salarySelector,
  (state) => state.getDetailNotifyIncome.dataSelected
);
